import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../store/hooks';
import { performLogout } from '../utils/logout';

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logout = async (options = {}) => {
    const {
      showConfirmation = true,
      redirectTo = '/',
      onSuccess = null,
      onError = null
    } = options;

    try {
      // Perform logout
      await performLogout(dispatch, navigate);
      
      // Redirect to specified route
      if (redirectTo) {
        navigate(redirectTo, { replace: true });
      }

      // Call success callback
      if (onSuccess) {
        onSuccess();
      }

      return true;
    } catch (error) {
      // Logout failed
      
      // Call error callback
      if (onError) {
        onError(error);
      }

      return false;
    }
  };

  return { logout };
};